export class CallTreatmentsSelect extends HTMLSelectElement {
  static get observedAttributes() { return ['no_change_option']; }

  attributeChangedCallback(name, ov, val) {
    switch (name) {
      case 'no_change_option':
        this.no_change_option = (val === 'true');
    }
  }

  constructor() {
    super();
    this.no_change_option = false;
    this.template = document.createElement('template');
    let _this = this;
    document.addEventListener("treatments_updated", function(e) { 
    _this.requestUpdate(e.detail.data) 
    });
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;
    let options = this.data.map(target => target.type == 'CALL' ? `<option value="${target.id}">${target.description}</option>`: '').join("");

    let first_option = this.no_change_option ? "<option value='no_change'>No Change</option>" : "<option value=''>Select</option>";

    this.template.innerHTML =`
    ${first_option}
    ${options}
    `
    let value = this.value;
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    this.value = value;
    if(this.selectedOptions.length == 0) {
      this.value = ""
    }
  }

  async connectedCallback() {
    let domain_id = this.getAttribute("domain_id") || document.querySelector("#object_id").value
    let res = await fetch("/admin/domains/"+domain_id+"/call_treatments");
    this.data = await res.json();

    let options = this.data.map(target => `<option value="${target.target_id}">${target.target_name}</option>`).join("");

    let no_change_option = this.no_change_option ? "<option value='no_change'>No Change</option>" : ""

    this.template.innerHTML =`
    ${no_change_option}
    <option value="">Select</option>
    ${options}
    `

    this.appendChild(this.template.content.cloneNode(true));
    this.value = this.getAttribute("data-selected");
    if(this.selectedOptions.length == 0) {
      this.value = this.getAttribute("no_change_option") == "true" ? "no_change" : ""
    }
  }
}

customElements.define('treatments-select', CallTreatmentsSelect, {extends: 'select'});

export class MessageTreatmentsSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
    let _this = this;
    document.addEventListener("treatments_updated", function(e) { 
    _this.requestUpdate(e.detail.data) 
    });
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    let options = this.data.map(message_treatment => message_treatment.type != 'TREATMENT' ? `<option value="${message_treatment.message_tree_id}">${message_treatment.description}</option>` : '').join("")
    this.template.innerHTML =`
    <option value=null>Choose</option>
    ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    this.value = this.getAttribute("data-selected");
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder(`/admin/domains/${this.getAttribute("domain_id")}/message_treatments/${this.getAttribute("type")}`, true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('message-treatments-select', MessageTreatmentsSelect, {extends: 'select'});

